import React, { useState, useEffect } from "react";
import heroVideo from "../img/gifs/documentary.mp4";
import heroMobileVideo from "../img/gifs/documetary-mobile.mp4"; // Video para mobile

const Hero = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Detectar si la pantalla es de tamaño móvil
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // Definir ancho máximo para considerar como mobile
    };

    // Comprobar tamaño de pantalla al cargar
    handleResize();

    // Añadir event listener para cambiar el estado cuando se redimensiona la ventana
    window.addEventListener("resize", handleResize);

    // Limpiar el event listener al desmontar el componente
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <section style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "10px" }}>
      <div style={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
        <video
          src={isMobile ? heroMobileVideo : heroVideo} // Mostrar el video según la pantalla
          autoPlay
          loop
          muted
          playsInline // para asegurar compatibilidad en iOS
          style={{
            maxWidth: isMobile ? "100%" : "100%",
            maxHeight: isMobile ? "100vh" : "80vh",
            objectFit: "cover"
          }}
        />
      </div>
    </section>
  );
};

export default Hero;
